import { cn } from "@/lib/utils";
import clsx from "clsx";
import { ReactNode } from "react";

type ButtonProps = {
  className?: string;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  isDisable?: boolean;
  children: ReactNode;
};

export function Button(props: ButtonProps) {
  return (
    <button
      disabled={props.isDisable}
      className={cn(`cursor-pointer text-white bg-primary h-[40px] w-full md:w-auto px-6 font-bold py-2 rounded transition-colors whitespace-nowrap ${props.isDisable ? 'opacity-50 cursor-not-allowed' : ''}`, props.className)}
      type={props.type}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}
